import Vue from 'vue'

const videoPlayer = require('vue-video-player/dist/ssr')

Vue.use(videoPlayer)
